import React, {useEffect, useState} from 'react';
import HeaderView from '../HeaderView';
import TextInput from '../../UI/Form/TextInput';
import TextArea from '../../UI/Form/TextArea';
import SubscriptionForm from './SubscriptionForm';
import {AppToast} from '../../HelperClasses/AppToast';
import {ToastContainer} from 'react-toastify';
import {checkSubscriptionForm} from './actions/checkSubscriptionForm';
import submitSubscriptionListing from './actions/submitSubscriptionListing';
import AppLoader from '../../HelperClasses/AppLoaderClasses/AppLoader';
import ToastPopup from '../../HelperClasses/AppLoaderClasses/ToastPopup';
import {useLocale} from '../../Localization/LocaleContext';
import {clearSubscriptionDraft, readSubscriptionDraft, subscriptionDraftKey, writeSubscriptionDraft} from './subscriptionDrafts';

const AddSubscriptionListing = ({onCloseModal, load_subscription_list}) => {
  const {translate: t} = useLocale();
  const draftKey = subscriptionDraftKey('new');
  const [subscriptin_listing_form, setSubscriptin_listing_form] = useState(() => ({
    title: '',
    description: '',
    amount: 0,
    sku: '',
    image_path: '',
    allowed_listings: 0,
    fee_fixed_per_order: 0,
    commission_percent_per_order: 0,
    currency_id: null,
    expiry_days: 0,
    type: '',
    active: true,
    ...readSubscriptionDraft(draftKey),
  }));

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    writeSubscriptionDraft(draftKey, subscriptin_listing_form);
  }, [draftKey, subscriptin_listing_form]);

  // onUpdateForm
  const onUpdateForm = ({key, value}) => {
    setSubscriptin_listing_form({
      ...subscriptin_listing_form,
      [key]: value,
    });
  };

  // saveListingButtonAction
  const saveListingButtonAction = () => {
    const checkup = checkSubscriptionForm({
      form_data: subscriptin_listing_form,
      t,
    });
    if (checkup) {
      submitSubscriptionListing({
        form_data: subscriptin_listing_form,
        setIsLoading,
        onSuccess,
        t,
      });
    }
  };

  const onSuccess = () => {
    ToastPopup({
      type: 'success',
      message: t('subscriptions.added_success', 'Subscription listing added successfully'),
    });
    clearSubscriptionDraft(draftKey);
    load_subscription_list();
    onCloseModal();
  };

  return (
    <div className="  w-full h-full py-4">
      <HeaderView
        title={t('subscriptions.add_title', 'Add new subscription product')}
        saveBtnTitle={t('common.save', 'Save')}
        saveBtn={() =>
          !isLoading
            ? saveListingButtonAction()
            : ToastPopup({type: 'warning', message: t('common.please_wait', 'Please wait…')})
        }
        backBtn={() => { clearSubscriptionDraft(draftKey); onCloseModal(); }}
      />
      {/* add Listing form */}
      <SubscriptionForm
        form_state={subscriptin_listing_form}
        onUpdateForm={onUpdateForm}
      />

      <ToastContainer />
      <AppLoader enable={!isLoading} />
    </div>
  );
};

export default AddSubscriptionListing;
